const dateRangeFilterConfig = {
  _id: 'dateRange',
  customField: 'dateRange',
  field: 'dateRange',
  name: 'Date Range',
  subtype: 'customDate',
  type: 'date',
};

const groupsFilterConfig = {
  _id: 'groupsName',
  field: 'groupsName',
  name: 'Groups',
  type: 'multiTree',
};

const initialSelectedFilter = [
  {
    condition: 'equals',
    field: 'dateRange',
    type: 'date',
    value: '7',
  },
];

export { dateRangeFilterConfig, groupsFilterConfig, initialSelectedFilter };
